module.exports = __webpack_public_path__ + "img/contact.470cdfea.png";